<template>
    <el-form label-position="top" ref="personalForm" label-width="100px">
        <el-form-item :label="$t('commons.displayLayout')" prop="layout">
            <el-radio v-model="layout" :label="1">{{$t('commons.displayLayout_1')}}</el-radio>
            <el-radio v-model="layout" :label="2">{{$t('commons.displayLayout_2')}}</el-radio>
            <el-radio v-model="layout" :label="3">{{$t('commons.displayLayout_3')}}</el-radio>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="savePersonalization">{{$t('commons.save')}}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>

export default {
    data() {
        return {
            layout: 1,
        }
    },
    created() {
        this.layout = this.$store.getters.displayLayout
    },
    methods: {
        // 保存个性化设置
        savePersonalization() {
            this.$store.dispatch('setDisplayLayout', this.layout)
            this.$message({
                message: this.$t('message.saveSuccess'),
                type: 'success'
            })
        }
    }
}
</script>
